/**
 * Bio component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import * as React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { useLocation } from "@reach/router"

const Bio = ({ useArticles = true, useTags = true } ) => {


  const data = useStaticQuery(graphql`
    query BioQuery {
      site {
        siteMetadata {
          author {
            name
            bio
            social {
              twitter
            }
          }
        }
      }
    }
  `)

  // Set these values by editing "siteMetadata" in gatsby-config.js
  const author = data.site.siteMetadata?.author;
  const social = data.site.siteMetadata?.author.social;

  return (
    <div className="bio">
        <hr className="divider"></hr>
        <StaticImage
          className="bio-avatar"
          layout="fixed"
          formats={["auto", "webp", "avif"]}
          src="../images/profile-pic.png"
          width={50}
          height={50}
          quality={95}
          alt="Profile picture"
        />
        {author?.name && (
          <div>
            <p>
              Par <strong><Link to="/about">{author.name}</Link></strong> {author?.bio || null}
            </p>
            <p className="list-group list-group-horizontal">{useArticles && <Link className="list-group-item btn btn-link" to="/article/page/">Tous les articles</Link>}{useTags && <Link className="list-group-item btn btn-link" to="/tags/">Tous les mots clés</Link>}</p>
          </div>
        )}
    </div>
  )
}

export default Bio
